"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _recompose = require("recompose");
var _reactI18next = require("react-i18next");
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var backgrounds = ['/images/probeton-slider-home1.jpg', '/images/probeton-slider-home2.jpg', '/images/probeton-slider-home3.jpg', '/images/probeton-slider-home4.jpg', '/images/probeton-slider-home5.jpg'];
var styles = function styles(theme) {
  return _defineProperty({
    root: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    wallpaper: {
      // backgroundImage: 'url(/images/backgrounds/death_valley.jpg)',
      backgroundImage: "url(".concat(backgrounds[Math.floor(Math.random() * backgrounds.length)], ")"),
      backgroundSize: 'cover',
      backgroundPosition: 'center 10%',
      backgroundRepeat: 'no-repeat'
    },
    gradient: {
      // background: 'linear-gradient(to right, #480048, #c04848)', // Solar storm
      // background: `linear-gradient(to right, ${theme.palette.background.default}, #480048)`, // Purple wisdom
    },
    filter: {
      // filter: 'contrast(2) brightness(.3)', // very dark dim
      // filter: 'contrast(1.5) brightness(.6)', // dark high contrast dim
      // filter: 'contrast(1.5) brightness(.9)', // dark + contrast boost
      filter: 'contrast(1.1) brightness(.9)' // small tweak
    },

    paper: {
      padding: 32,
      margin: '0 auto',
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      transform: 'translateY(0)',
      borderRadius: 0,
      paddingTop: 120
    },
    logo: {
      display: 'block',
      background: 'url("/images/probeton_logo_t.png")',
      height: 180,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      marginBottom: 0
    },
    slogan: {
      display: 'none',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      color: 'white',
      fontSize: '4em',
      padding: '1.5em',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      textAlign: 'center'
    }
  }, theme.breakpoints.up('sm'), {
    paper: {
      maxWidth: 380,
      position: 'relative',
      transform: 'translateY(96px)',
      borderRadius: 2,
      background: 'rgba(255,255,255,0.8)',
      paddingTop: 80
    },
    slogan: {
      display: 'block'
    }
  });
};
var AuthLayout = function AuthLayout(_ref2) {
  var classes = _ref2.classes,
    children = _ref2.children,
    onReset = _ref2.onReset;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root, classes.wallpaper, classes.filter, classes.gradient)
  }), /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    className: classes.paper,
    elevation: 3
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.logo
  }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "headline"
  }, "Probeton Extranet"), children, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onReset
  }, "Reset data")));
};
AuthLayout.propTypes = {
  children: _propTypes["default"].node.isRequired,
  classes: _propTypes["default"].object.isRequired,
  t: _propTypes["default"].func.isRequired,
  onReset: _propTypes["default"].func
};

// prettier-ignore
var _default = (0, _recompose.compose)((0, _styles.withStyles)(styles))(AuthLayout);
exports["default"] = _default;